module.exports = __webpack_public_path__ + "static/media/add patient.ac7ecdec.svg";